import { useEffect, useRef } from "react"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { AppSidebar } from "./AppSidebar"
import { HeroSection } from "./HeroSection"
import { CourseGrid } from "./CourseGrid"
import ImpersonationBanner from "./ImpersonationBanner"

gsap.registerPlugin(ScrollTrigger)

export function MainLayout({ children }) {
  const containerRef = useRef(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Verificar se elementos existem antes de animar
      const fadeInElements = containerRef.current?.querySelectorAll(".fade-in")
      if (fadeInElements && fadeInElements.length > 0) {
        gsap.fromTo(
          fadeInElements,
          { opacity: 0, y: 30 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.1,
            ease: "power2.out",
          },
        )
      }

      // Animação de scroll para as seções
      const scrollRevealElements = containerRef.current?.querySelectorAll(".scroll-reveal")
      if (scrollRevealElements && scrollRevealElements.length > 0) {
        scrollRevealElements.forEach((element) => {
          gsap.fromTo(
            element,
            { opacity: 0, y: 50 },
            {
              opacity: 1,
              y: 0,
              duration: 0.6,
              scrollTrigger: {
                trigger: element,
                start: "top 80%",
                end: "bottom 20%",
                toggleActions: "play none none reverse",
              },
            },
          )
        })
      }
    }, containerRef)

    return () => ctx.revert()
  }, [])

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950">
      <ImpersonationBanner />
      <AppSidebar />
      <div ref={containerRef} className="ml-64 min-h-screen">
        <main className="relative">
          {children ? (
            <div className="p-6 lg:p-8">
              {children}
            </div>
          ) : (
            <>
              <HeroSection />
              <CourseGrid />
            </>
          )}
        </main>
      </div>
    </div>
  )
} 